import { AnalyticsService } from '@kfc-global/react-shared/analytics';
import { getDataLayer } from 'common/utilities/utils';

/**
 *
 * @param {*} data - all routing data - Array
 */
export const modifyData = loyaltyContent => {
  const {
    DesktopImage,
    button,
    email = '',
    headline = '',
    subHeadline = '',
    mobileImage,
    subHeadline2 = '',
    icon,
  } = loyaltyContent;
  // get image related inforamtions
  const { url: desktopSrc = '' } = DesktopImage && DesktopImage.fields && DesktopImage.fields.file;
  const { url: mobileSrc = '' } = mobileImage && mobileImage.fields && mobileImage.fields.file;
  // get all button related inforamtions
  const { buttonText = '', name: buttonItem = '', url: buttonUrl = '' } = (button && button?.fields) || {};
  const stripesIcon = icon?.fields?.desktopImage?.fields?.file?.url;
  return {
    desktopSrc,
    mobileSrc,
    email,
    headline,
    subHeadline,
    buttonText,
    buttonItem,
    buttonUrl,
    subHeadline2,
    stripesIcon,
  };
};

export const setLoyaltyCrmAnalyticsData = async analyticsData => {
  const analyticsItems = [];
  analyticsItems.push(analyticsData);
  await AnalyticsService.registerEvent(
    undefined,
    {
      data: analyticsItems[0],
    },
    getDataLayer,
  );
};
